import * as React from 'react';
import { useSearchParams } from 'react-router-dom';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import useAxios from '../utils/useAxios';
import PageShell from './layout/PageShell';
import StockTab from './inventory/StockTab';
import MovementsTab from './inventory/MovementsTab';
import SuppliersTab from './inventory/SuppliersTab';
import OrdersTab from './inventory/OrdersTab';

const TABS = [
  { key: 'stock', label: 'Existencias' },
  { key: 'movements', label: 'Movimientos' },
  { key: 'suppliers', label: 'Proveedores' },
  { key: 'orders', label: 'Órdenes de compra' },
] as const;

const Inventory = () => {
  const axios = useAxios();
  const [params, setParams] = useSearchParams();
  const tab = TABS.find(t => t.key === params.get('tab'))?.key ?? 'stock';
  const [locations, setLocations] = React.useState<any[]>([]);

  React.useEffect(() => {
    axios.get('api/locations/').then(r => setLocations(r.data ?? [])).catch(() => {});
  }, [axios]);

  return (
    <PageShell
      title="Inventario"
      subtitle="Existencias por sucursal, movimientos, proveedores y compras"
      toolbar={
        <Tabs
          value={tab}
          onChange={(_, v) => setParams(v === 'stock' ? {} : { tab: v }, { replace: true })}
          variant="scrollable"
          allowScrollButtonsMobile
        >
          {TABS.map(t => <Tab key={t.key} value={t.key} label={t.label} />)}
        </Tabs>
      }
    >
      {tab === 'stock' && <StockTab locations={locations} />}
      {tab === 'movements' && <MovementsTab locations={locations} />}
      {tab === 'suppliers' && <SuppliersTab />}
      {tab === 'orders' && <OrdersTab locations={locations} />}
    </PageShell>
  );
};

export default Inventory;
